.search {
  position: absolute;
  right: 0;
  top: 15px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.search-toggle {
  position: relative;
  @include text-size(20);
  @include line-height(30);
  font-weight: 600;
  color: $secondary;
  padding-left: 32px;
  user-select: none;

  span {
    &:after {
      content: "Search";
    }
  }

  svg {
    @include svg-format(16px, 16px, $secondary);
    margin-left: 7px;
  }

  &::before {
    content: "";
    width: 1px;
    height: 41px;
    background: #707070;
    opacity: .5;
    position: absolute;
    left: 0;
    top: -10px;
  }

  .close-icon {
    display: none;
  }

  &:hover {
    span {
      text-decoration: underline;
    }
  }
}

.search-toggle-mobile {
  display: none;
}

.search.is-open {

  .search-toggle {
    span {
      &:after {
        content: "Close"
      }
    }

    .close-icon {
      display: inline-block;
    }

    .open-icon {
      display: none;
    }

    &::before {
      display: none;
    }
  }

  .search-form-inner {
    flex-grow: 1;
  }

  .kdx-site-search {
    animation: dtSearchIn linear 300ms forwards;
    flex-grow: 1;
  }
}

@keyframes dtSearchIn {
  from {
    opacity: 0;
    max-width: 0;
  }
  to {
    opacity: 1;
    max-width: 100%;
  }
}

.kdx-site-search {
  opacity: 0;
  max-width: 0;
  overflow: hidden;
  position: relative;
  padding: 0 0 2px;
  transition: all 500ms;

  &.input-group {
    > .form-control {
      margin: 0;

      &:focus,
      &:active {
        z-index: auto; // Bootstrap override
      }
    }

    // Bootstrap override
    > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
      margin: 0;
    }
  }

  .input-group-text {
    background-color: #fff;
    border: none;
    border-radius: 0;
  }

   .form-control {
    border: none;
    border-radius: 0;
    @include text-size(15);
    color: #666d70;
    max-height: 45px;
    padding: 0;
    padding: 10px 10px 10px 35px;
    transform: translateY(-5px);

    + .input-group-text {
      padding: 0;
    }

    &::placeholder {
      color: $senary;
      @include text-size(15);
    }

    &:active,
    &:focus {
      border: none;
      outline: none;
      box-shadow: none;
    }
  }

  .svg-icon {
    svg {
      @include svg-format(16px, 16px, $secondary);
    }
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    display: block;
    width: 100%;
    height: 1px;
    background-color: #707070;
    bottom: 0;
    left: 0;
    z-index: 1;
    transform: translateX(0);
    @include transitionDefault(transform);
  }

  &:before {
    background-color: $primary;
    transform: translateX(-100%);
    @include transitionDefault(transform);
  }

  &.has-focus {
    &:before,
    &:after {
      transform: translateX(100%);
      @include transitionDefault(transform);
    }

    &:before {
      box-shadow: 0px 0px 6px rgba(111, 178, 229, 1);
      transform: translateX(0);
    }
  }

  button[type="submit"] {
    position: absolute;
    z-index: 2;
    left: 0;
    top: 4px;

    &:hover {
      opacity: .7;
    }
  }

  @include media-breakpoint-down(lg) {
    flex-wrap: nowrap;
  }
}

@include media-breakpoint-up(xl) {
  .search.is-open {
    width: calc(100% - 177px);
    background: #fff;
    padding-left: 23px;
    padding-bottom: 12px;
    z-index: 2;
  }
}

@include media-breakpoint-down(xl) {
  .kdx-site-search  {
    transition: none;
  }
  
  .search-toggle {
    display: none;
  }

  .search-toggle-mobile {
    position: absolute;
    top: -3px;
    right: 80px;
    display: block;

    svg {
      @include svg-format(16px, 16px, $secondary);
    }

    .close-icon {
      display: none;
    }

    .text {
      display: block;
      @include text-size(14);
      font-weight: 400;

      &::after {
        Content: "Search";
      }
    }
  }

  .search.is-open {
    .search-toggle-mobile {
      .open-icon {
        display: none;
      }
      .close-icon {
        display: block;
      }
      .text {
        &:after {
          content: "Close";
        }
      }
    }

    .search-form-inner {
      position: absolute;
      top: 65px;
      right: 0;
      background: #fff;
      padding: 20px 50px;
      width: 100vw;
      max-width: none;
      box-shadow: inset 0px 2px 8px 0px rgba(0,0,0,0.15);
    }
  }
}
